import './App.css';
import AllRoutes from './AllRoutes';
function App() {
  return (
    <div className="">
      <AllRoutes />

    </div>
  );
}

export default App;
